// REVERT BEFORE MERGING PR!!!
import { TimePicker as AntdTimePicker } from "antd"
import locale from "antd/es/date-picker/locale/ar_EG"
import cx from "clsx"
import dayjs from "dayjs"
import { useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import DateTime from "../../../utils/dateTime"
import styles from "./index.module.less"

const TimePicker = props => {
  const {
    preSelectedDate,
    value,
    onChange,
    minuteStep = 5,
    isTimeDisabled = true,
    disablePastToday = false,
    className,
    disableTimeRange,
    timeRange,
    ...rest
  } = props
  const [startTime, setStartTime] = useState()
  const [endTime, setEndTime] = useState()
  const { locale: appLanguage } = useSelector(state => state.app.configs)
  const currentDate = dayjs()

  useEffect(() => {
    if (preSelectedDate && DateTime.isSameDay(preSelectedDate, currentDate) && disablePastToday) {
      value[0] = currentDate
      value[1] = currentDate
    }
  }, [preSelectedDate])

  useEffect(() => {
    if (value) {
      setStartTime(value[0])
      setEndTime(value[1])
    }
  }, [value])

  const range = (start, end) => {
    const result = []
    for (let i = start; i < end; i++) {
      result.push(i)
    }
    return result
  }

  const disabledTime = useCallback(
    (date, type) => {
      if (date && disableTimeRange && timeRange && preSelectedDate) {
        const startingTime = type === "end" && startTime ? startTime : timeRange?.startTime
        const startHour = startingTime ? DateTime.getHourFromDate(startingTime) : 0
        const startMinute = startingTime ? DateTime.getMinutesFromDate(startingTime) : 0

        const endHour = timeRange?.endTime ? DateTime.getHourFromDate(timeRange?.endTime) : 23
        const endMinute = timeRange?.endTime ? DateTime.getMinutesFromDate(timeRange?.endTime) : 59

        return {
          disabledHours: () => {
            return [...range(0, startHour), ...range(endHour + 1, 24)]
          },
          disabledMinutes: selectedHour => {
            if (selectedHour === startHour && selectedHour === endHour) {
              return [...range(0, startMinute), ...range(endMinute + 1, 60)]
            }
            if (selectedHour === startHour) {
              return range(0, startMinute)
            }
            if (selectedHour === endHour) {
              return range(endMinute + 1, 60)
            }
            return []
          },
        }
      }
      if (
        date &&
        preSelectedDate &&
        DateTime.isSameDay(preSelectedDate, currentDate) &&
        (disablePastToday || DateTime.hasSameHoursandMinutes(preSelectedDate, currentDate))
      ) {
        return {
          disabledHours: () => {
            const hour =
              type === "end" && startTime ? DateTime.getHourFromDate(startTime) : DateTime.getHourFromDate(currentDate)
            return range(0, hour)
          },
          disabledMinutes: selectedHour => {
            const comparisonHour = DateTime.getHourFromDate(startTime) || DateTime.getHourFromDate(currentDate)
            if (type === "end") {
              if (selectedHour < comparisonHour) {
                return range(0, 59)
              }
              if (selectedHour === comparisonHour) {
                const minutes = startTime
                  ? DateTime.getMinutesFromDate(startTime)
                  : DateTime.getMinutesFromDate(currentDate)
                return range(0, minutes)
              }
            } else {
              const dateHour = DateTime.getHourFromDate(currentDate)
              if (selectedHour < dateHour) {
                return range(0, 59)
              }
              if (selectedHour === dateHour) {
                return range(0, DateTime.getMinutesFromDate(currentDate))
              }
            }
            return []
          },
        }
      } else if (type === "end" && startTime) {
        return {
          disabledHours: () => {
            const hour = DateTime.getHourFromDate(startTime)
            return range(0, hour)
          },
          disabledMinutes: selectedHour => {
            const startHour = DateTime.getHourFromDate(startTime)
            if (selectedHour < startHour) {
              return range(0, 59)
            } else if (selectedHour === startHour) {
              const minutes = DateTime.getMinutesFromDate(startTime)
              return range(0, minutes)
            }
            return []
          },
        }
      }
      return {
        disabledHours: () => [],
        disabledMinutes: () => [],
      }
    },
    [preSelectedDate, startTime, timeRange, disableTimeRange]
  )

  const handleChangeTime = dates => {
    if (dates) {
      let edTime = dates[1]
      let stTime = DateTime.getDateAndTime(dates[0])
      if (isTimeDisabled) {
        if (
          DateTime.isAfterMentionedDate(stTime, dates[1]) &&
          DateTime.isSameDay(DateTime.getHoursAfterDateProvided(DateTime.getDateAndTime(stTime), 1), stTime)
        ) {
          edTime = DateTime.getHoursAfterDateProvided(stTime, 1)
        } else if (
          DateTime.isAfterMentionedDate(stTime, dates[1]) &&
          !DateTime.isSameDay(DateTime.getHoursAfterDateProvided(DateTime.getDateAndTime(stTime), 1), stTime)
        ) {
          edTime = DateTime.getEndOfDay(stTime)
        }
      }
      setEndTime(edTime)
      // onChange([dates[0], edTime])
    }
  }

  return (
    <AntdTimePicker.RangePicker
      order={false}
      use12Hours
      format="h:mm a"
      disabledTime={disabledTime}
      {...(disableTimeRange && timeRange?.startTime && {
        defaultOpenValue: dayjs(timeRange.startTime).set("minute", 0),
      })}
      value={[startTime, endTime]}
      onChange={dates => {
        if (dates) {
          handleChangeTime(dates)
        } else {
          setStartTime(null)
          setEndTime(null)
          onChange([null, null])
        }
      }}
      onOk={dates => {
        onChange(dates)
        setStartTime(dates[0])
        setEndTime(dates[1])
      }}
      hideDisabledOptions
      minuteStep={minuteStep}
      locale={appLanguage === "en" ? [] : locale}
      className={cx(styles.timePicker, className)}
      {...rest}
    />
  )
}
export default TimePicker
